import Cookies from 'js-cookie';

export const abTestHomePages = [
  'pages/ab-home'
];

export const pdpAbTestPages = [
  'pages/ab-ketone',
  'pages/ab-ketone-iq-shots',
  'pages/ab-ketone-iq-classic-shot-peach',
  'pages/ab-ketone-iq-classic-shot-variety',
  'pages/ab-ketone-iq-caffeine',
  'pages/ab-ketone-iq-mixed-bundle'
];

const cookieName = 'ab_group_landing_path';
const pathPrefix = '/pages/ab-';

export class ABTestGroup {
  static get() {
    return Cookies.get(cookieName);
  }

  static set() {
    const currentPath = window.location.pathname;

    if (currentPath.includes(pathPrefix)) {
      Cookies.set(cookieName, currentPath, { expires: 2 });
    }
  }
}
